module.exports = __webpack_public_path__ + "img/1506423373.683ce74f.jpg";